// src/modules/app-views/_apps/appmulti/receivables/pages/Init/components/tableColumns/statusColumn.js
import { Tag } from 'antd';
import translateX from 'utils/translateX';
import receivablesModuleService from 'modules/app-views/_apps/appmulti/receivables/service';

function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 190,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'center',
    render: (_, r) => {
      const status = r?.__statusView || r?.status;
      if (!status) return '—';
      const color = receivablesModuleService.getStatusColor(status);
      return <Tag color={color}>{translateX(status)}</Tag>;
    },
  };
}

export default statusColumn;
